import { render, staticRenderFns } from "./InclusiveSustainability.vue?vue&type=template&id=6b448236&scoped=true&"
import script from "./InclusiveSustainability.vue?vue&type=script&lang=js&"
export * from "./InclusiveSustainability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b448236",
  null
  
)

export default component.exports